interface WeatherServiceIconProps {
  cloudColor?: string
  sunColor?: string
  width?: number
  height?: number
}

const WeatherServiceIcon = ({
  cloudColor = "#9ca3af",
  sunColor = "#f9b233",
  width = 24,
  height = 18.6,
}: WeatherServiceIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 559 434"
    >
      <path
        fill={sunColor}
        d="M267.493 126.704c-1.972 1.625-.993 4.762 1.528 5.173a167 167 0 0 1 33.437 9.082 6.38 6.38 0 0 0 4.947-.163c10.599-4.83 22.241-7.463 34.253-7.463 45.95 0 83.334 37.384 83.334 83.334 0 4.777-.412 9.501-1.216 14.136a3.15 3.15 0 0 0 2.167 3.548 105.8 105.8 0 0 1 23.456 10.493c2.341 1.409 5.438.266 6.043-2.399a116.4 116.4 0 0 0 2.883-25.778c0-64.334-52.333-116.667-116.667-116.667-27.444 0-53.578 9.739-74.165 26.704M341.658 66.667c9.2 0 16.667-7.467 16.667-16.667V16.667c0-9.2-7.467-16.667-16.667-16.667-9.208 0-16.666 7.467-16.666 16.667V50c0 9.2 7.458 16.667 16.666 16.667M459.517 115.475c4.266 0 8.525-1.625 11.783-4.883l23.567-23.567c6.508-6.508 6.508-17.058 0-23.567-6.509-6.508-17.059-6.508-23.567 0l-23.567 23.567c-6.508 6.508-6.508 17.058 0 23.567a16.6 16.6 0 0 0 11.784 4.883M541.658 200h-33.333c-9.208 0-16.667 7.467-16.667 16.667s7.459 16.666 16.667 16.666h33.333c9.2 0 16.667-7.466 16.667-16.666S550.858 200 541.658 200M212.017 110.592a16.6 16.6 0 0 0 11.783 4.883 16.6 16.6 0 0 0 11.783-4.883c6.509-6.509 6.509-17.059 0-23.567l-23.566-23.567c-6.509-6.508-17.059-6.508-23.567 0-6.508 6.509-6.508 17.059 0 23.567z"
      />
      <path
        fill={cloudColor}
        fillRule="evenodd"
        d="m446.292 268.225.085-.173c-8.838-6.7-18.994-11.725-30.004-14.606l-.015.029c-7.875-2.208-16.133-3.475-24.691-3.475-4.234 0-9.267.658-14.084 1.533-13.4-45.925-48.783-81.125-93.416-95.008l.009-.009a143.4 143.4 0 0 0-38.244-6.447 210 210 0 0 0-4.265-.069c-63.867 0-118.492 41.767-135.925 101.533-4.809-.875-9.85-1.533-14.075-1.533C41.117 250 0 291.125 0 341.667c0 50.541 41.117 91.666 91.667 91.666h300c50.541 0 91.666-41.125 91.666-91.666 0-30.067-14.616-56.717-37.041-73.442M91.667 400h300C423.825 400 450 373.825 450 341.667s-26.175-58.334-58.333-58.334c-2.284 0-6.017.575-9.942 1.359V300c0 9.2-7.467 16.667-16.667 16.667S348.392 309.2 348.392 300v-26.783c-8.925-52.134-53.625-89.884-106.725-89.884-53.092 0-97.784 37.734-106.725 89.842V300c0 9.2-7.467 16.667-16.667 16.667S101.608 309.2 101.608 300v-15.317c-3.916-.783-7.633-1.35-9.941-1.35-32.159 0-58.334 26.175-58.334 58.334 0 32.158 26.175 58.333 58.334 58.333"
        clipRule="evenodd"
      />
    </svg>
  )
}

export default WeatherServiceIcon
